import {FormSubmitHandler} from 'platform/components';

import {usePostTireWarehouseMutation} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {ApiError, composePath, useNavigate} from 'shared/web';

import {GeneralTab} from '../../components/GeneralTab';
import {GeneralTabFormType} from '../../schemas/generalTabFormSchema';

export function Create() {
  const [postTireWarehouse, postTireWarehouseStatus] = usePostTireWarehouseMutation();
  const navigate = useNavigate();

  const createTireWarehouse: FormSubmitHandler<GeneralTabFormType> = async (
    data,
    _setErrors,
    _reset,
    blockerContext
  ) => {
    await postTireWarehouse({body: data})
      .unwrap()
      .then((res) => {
        if (blockerContext?.wasSubmittedFromBlocker) {
          return;
        }

        if (res?.warehouseId) {
          navigate(
            composePath(settingsRoutes.tireWarehousesDetail, {params: {id: res.warehouseId}})
          );
        }
      })
      .catch((e: ApiError) =>
        handleApiError(e, {signalApiError: blockerContext?.reportApiFailure})
      );
  };

  return (
    <SettingsTemplate
      header={{
        breadcrumbs: [
          {
            label: i18n.t('entity.tireWarehouses.labels.title'),
            href: settingsRoutes.tireWarehouses,
          },
        ],
        title: i18n.t('entity.tireWarehousesCreate.labels.title'),
      }}
      tabs={[
        {
          queryId: 'general',
          title: i18n.t('general.labels.general'),
          content: (
            <GeneralTab
              onSubmit={createTireWarehouse}
              isLoading={postTireWarehouseStatus.isLoading}
            />
          ),
        },
        {
          queryId: 'location',
          title: i18n.t('entity.tireWarehouses.labels.storageLocations'),
          content: null,
          isDisabled: true,
        },
      ]}
      isCreating
      data-testid={testIds.settings.tireWarehousesCreate('template')}
    />
  );
}
